// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination[data-v-155a4f36]{justify-content:center;display:flex}.pagination>.btn[data-v-155a4f36]{margin-right:5px}.pagination[data-v-155a4f36]{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
